<template>
	<div class="lineup-player-wrapper">
		<div
			class="lineup-player"
		>
			<div
				v-if="playerImage"
				class="player-image"
				:style="{
					background: `var(--color-grey-950) url(${playerImage}) no-repeat center center / cover`,
				}"
			>
				<div class="player-number">
					<p>{{ playerNumber }}</p>
				</div>
			</div>
			<div
				v-else
				class="player-image-fallback"
			>
				<Icon
					icon-name="single"
					size="lg"
				/>
			</div>
			<div class="player-info">
				<div class="player-name">
					<p class="text-ellipsis">
						{{ playerFirstName }} {{ playerLastName }}
					</p>
				</div>
				<div class="player-country">
					<p>{{ playerCountry }}</p>
				</div>
			</div>
		</div>
		<div
			:class="{'last': isLast}"
			class="divider"
		/>
	</div>
</template>

<script>
export default {
	name:  'LineupItem',
	props: {
		player: {
			type:    Object,
			default: () => {},
		},
		isLast: {
			type:    Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		playerFirstName() {
			if (!this.player) {
				return null;
			}
			return this.player.firstName;
		},
		playerLastName() {
			if (!this.player) {
				return null;
			}
			return this.player.lastName;
		},
		playerAge() {
			if (!this.player || !this.player.birthdate) {
				return null;
			}
			const age =
				new Date().getTime() - new Date(this.player.birthdate).getTime();
			return Math.floor(age / 31536000000);
		},
		playerCountry() {
			if (!this.player || !this.player.country) {
				return null;
			}
			return this.player.country.cca3;
		},
		playerImage() {
			if (!this.player || !this.player.imageUrl) {
				return null;
			}
			return this.$Helpers && this.player.imageUrl.indexOf('placeholder') === -1
				? this.$Helpers.getScaledImageUrl(this.player.imageUrl, 100)
				: this.player.imageUrl;
		},
		playerNumber() {
			if (!this.player) {
				return null;
			}
			return this.player.number;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.lineup-player-wrapper {
	display: flex;
	flex-direction: column;
	margin-top: -1px;
}

.divider {
	height: 1px;
	margin-left: 8px;
	margin-right: 8px;
	background: var(--color-grey-900);

	&.last {
		margin-left: 8px;
		margin-right: 8px;
	}
}

.lineup-player {
	cursor: pointer;
	display: flex;
	align-items: center;
	height: 72px;
	padding-left: 8px;

	&:hover {
		background: var(--color-grey-950);
	}
}

.player-info {
	display: flex;
    justify-content: space-between;
	flex-grow: 1;
    width: 0; // for text overflow
}

.player-country {
	margin-right: 8px;
	@include text-sm-2;
}

.player-name {
	margin-right: 10px;
    min-width: 0; // for text overflow
	margin-left: 32px;
	@include text-md-1
}

.text-ellipsis{
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.player-number {
	position: absolute;
	border: 1px solid var(--color-soft-white);
	border-radius: 50%;
	bottom: 0;
	background: var(--color-black);
	right: -10px;
	width: 25px;
	height: 25px;
	display: flex;
	align-items: center;
	justify-content: center;

	body.-t-light & {
		background-color: var(--color-white);
	}
}

.player-number p {
	@include text-sm-1(true);
	text-align: center;
}

.player-image-fallback {
	border-radius: 50%;
	border: 1px solid var(--color-grey-850);
	width: 56px;
	height: 56px;
	display: flex;
	justify-content: center;
	align-items: center;

	::v-deep svg {
		color: var(--color-grey-400);
	}
}

.player-image {
	border: 1px solid var(--color-grey-850);
	border-radius: 50%;
	width: 56px;
	height: 56px;
	position: relative;
}
</style>
